module.exports = __webpack_public_path__ + "static/media/ram.02355684.jpg";